import { CustomerRequest } from '@app/models/customer/CustomerRequest';
import { CustomerResponse } from '@app/models/customer/CustomerResponse';
import { post, get } from './http.api';
import { CustomerDTO } from '@app/models/customer/CustomerDTO';
import {
  CustomerTableData,
  CustomerTableDataResponse,
  CustomerTableRow,
  CustomerTableOptions,
} from '@app/models/customer/customers.table.dto';
import { Customer } from '@app/models/customer/Customer';

export const registerCustomer = async (customerData: CustomerRequest) => {
  try {
    const response = await post<any>('customer/register', customerData, undefined, false);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCustomerTableData = async (parameters: CustomerTableOptions): Promise<CustomerTableData> => {
  console.log(parameters);
  try {
    const { data, status } = await get<CustomerTableDataResponse>('customers', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data: ${data}`);

    const result = data?.customers.data.map((rawData: CustomerTableRow) => ({
      id: rawData.id,
      first_name: rawData.first_name,
      last_name: rawData.last_name,
      email: rawData.email,
      contact_no: rawData.contact_no,
      customer_type: rawData.customer_type,
      status: rawData.status,
    }));

    return {
      data: result,
      pagination: {
        current: data.customers.current_page,
        pageSize: data.customers.per_page,
        total: data.customers.total,
      },
      status_options: data.status_options,
      customer_type_options: data.customer_type_options,
    };
  } catch (error: any) {
    throw error;
  }
};

export const getVerifiedCustomers = async (keyword: any): Promise<Customer> => {
  try {
    const { data, status } = await get<Customer>(`customers/verified`, { params: { email: keyword } }, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const viewCustomer = async (id: number): Promise<CustomerDTO> => {
  try {
    const { data, status } = await get<CustomerDTO>(`customers/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createCustomer = async (): Promise<CustomerDTO> => {
  try {
    const { data, status } = await get<CustomerDTO>(`customers/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeCustomer = async (customerData: CustomerRequest) => {
  try {
    const response = await post<any>('customers/create', customerData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const editCustomer = async (id: number): Promise<CustomerDTO> => {
  try {
    const { data, status } = await get<CustomerDTO>(`customers/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const updateCustomer = async (id: number, customerData: CustomerRequest) => {
  try {
    const response = await post<any>(`customers/${id}/edit`, customerData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const verifyCustomer = async (id: number) => {
  try {
    const response = await post<any>(`customers/${id}/verify`, undefined, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};
